import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_2 = { class: "form-control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.hasForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_localized_text, {
            localizedKey: "Form di acquisto",
            text: "Form di acquisto"
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasForm)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.answers, (value, key, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "form-group",
            key: key
          }, [
            _createElementVNode("label", null, _toDisplayString(key), 1),
            _createElementVNode("span", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  _createTextVNode(_toDisplayString(item), 1),
                  (i < value.length - 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(",")
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ])
          ]))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}